import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 19 35", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m18.71 16.41-16.54-16.41-2.11 2 15.22 15.26-15.28 15.26 2.19 2 16.52-16.39v-.05a1.22 1.22 0 0 0 0-1.67z" }));
const ForwardRef = forwardRef(SvgArrow);
export default ForwardRef;
